// auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {LocalStorage} from '../localstorage.service';
import {User} from '../../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  public loggedUser: User
  constructor( private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.loggedUser   = JSON.parse(localStorage.getItem(LocalStorage.LOGGED_USER)) as User;
    if ((this.loggedUser != null) && (this.loggedUser != undefined)) {
      return true;
    } else {
      // Store the attempted URL for redirecting after login
      LocalStorage.redirectUrl = state.url;

      // Navigate to the login page
      return this.router.navigateByUrl('');
    }
  }
}
